import { render, staticRenderFns } from "./TagBox.vue?vue&type=template&id=46a89ead&scoped=true"
import script from "./TagBox.vue?vue&type=script&lang=js"
export * from "./TagBox.vue?vue&type=script&lang=js"
import style0 from "./TagBox.vue?vue&type=style&index=0&id=46a89ead&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a89ead",
  null
  
)

export default component.exports